// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AQCg","toggleWrap":"styles_toggleWrap__2y7qg","content":"styles_content__2VtLV","selectAreaCode":"styles_selectAreaCode__eLx72"};